import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class TodoItem extends Component {
  itemStyle = () => {
    return{
      background: 'lightgrey',
      padding: '10px',
      borderBottom: '1px red dotted',
      textDecoration: this.props.todo.completed ? 
      'line-through' : 'none'
    }
  }
  render() {
    const { id, title } = this.props.todo;
    return (
      <div style={this.itemStyle()}>
        <p>
          <input type="checkbox" onChange={this.props.toggleComplete.bind
          (this, id)} /> {' '}
          {title}
          <button onClick={this.props.delTodo.bind(this, id)} style={btnStyle}>x</button>
        </p>
      </div>
    )
  }        
}
//PropTypes
TodoItem.propTypes={
  todo:PropTypes.object.isRequired,
  toggleComplete:PropTypes.func.isRequired,
  delTodo:PropTypes.func.isRequired,
}
const btnStyle = {
  background: '#ff0000',
  color: '#fff',
  border: 'none',
  padding: '5px 8px',
  borderRadius: '50%',
  cursor: 'pointer',
  float: 'right'
}

export default TodoItem
